module.exports = __webpack_public_path__ + "static/media/0276_Medium.844840a5.jpg";